import { render, staticRenderFns } from "./create_project_page_mo.vue?vue&type=template&id=79553bd6&scoped=true&"
import script from "./create_project_page_mo.vue?vue&type=script&lang=js&"
export * from "./create_project_page_mo.vue?vue&type=script&lang=js&"
import style0 from "./create_project_page_mo.vue?vue&type=style&index=0&id=79553bd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79553bd6",
  null
  
)

export default component.exports